import * as Cesium from "cesium";
import type { MeasureMode } from "../types";

export default async function initCesiumMeasure(viewer: any) {
  viewer?.screenSpaceEventHandler?.setInputAction((click: any) => {
    console.log("Measure click", click.position);
  }, 0);
}

export function createCesiumMeasure(viewer: any, mode: MeasureMode) {
  let handler: any;

  return {
    activate() {
      console.log("Activating Cesium measure mode:", viewer, mode);

      handler = viewer.screenSpaceEventHandler?.createScreenSpaceHandler();

      handler.setInputAction((click: any) => {
        const cartesian = viewer.scene?.pickPosition(click.position);
        viewer.measureTool?.addPoint(cartesian);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },

    deactivate() {
      if (handler) handler.destroy();
    },
  };
}
